import axios from "axios";

export function getAWSReadOnlyPolicy ({ service, label, type }) {
    return axios.get(`https://sedai-onboarding-templates-prod.s3.us-east-1.amazonaws.com/nested/sedai-integration-include-${service}-r.json`).then(({ data }) => ({ type, label, data }))
}

export function getAWSReadWritePolicy ({ service, label, type }) {
    return axios.get(`https://sedai-onboarding-templates-prod.s3.us-east-1.amazonaws.com/nested/sedai-integration-include-${service}-rw.json`).then(({ data }) => ({ type, label, data }))
}

export function getAWSReadOnlyPolicies (readOnlyPolicies) {
    return Promise.all(readOnlyPolicies.map(getAWSReadOnlyPolicy)).then((results) => results.flat(1))
}

export function getAWSReadWritePolicies (readWritePolicies) {
    return Promise.all(readWritePolicies.map(getAWSReadWritePolicy)).then((results) => results.flat(1))
}